// @flow
import { loadStripe } from "@stripe/stripe-js/pure";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useFunctions } from "reactfire";
import {useState} from "react";

type Props = {
  renderButton: Function,
  gameId: string,
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function TicketPayButton({ renderButton, gameId }: Props) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const functions = useFunctions();
  const { enqueueSnackbar } = useSnackbar();

  const payTicket = async () => {
    setLoading(true);
    const addTicketReservationPayment = functions.httpsCallable(
      "addTicketReservationPayment"
    );

    await addTicketReservationPayment({gameId})
      .then(async (result) => {
        const { sessionId } = result.data;
        if (sessionId != null) {
          const stripe = await stripePromise;
          // When the customer clicks on the button, redirect them to Checkout.
          const result = await stripe.redirectToCheckout({
            sessionId: sessionId,
          });

          if (result.error) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
            console.error(result.error);
            enqueueSnackbar(result.error.message, { variant: "error" });
          }
        }
        return history.push(`/ticket/${gameId}`);
      })
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
        console.error(error);
        setLoading(false);
      });
  };
  return renderButton(payTicket, loading);
}

export default TicketPayButton;
